import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },

  heading: {
    fontSize: "14px",
    fontWeight: 700,
    marginTop: "15px",
    marginBottom: "15px",
  },
  tdTotal: {
    fontSize: "14px",
    fontWeight: 700,
    marginTop: "15px",
    marginBottom: "15px",
  },
  blueTable: {
    border: "1px solid #97b1de",
    borderCollapse: "collapse",
    marginBottom: "15px",
    fontSize: "14px",
    tableLayout: "fixed",
    width: "100%",
  },
  tableCells: {
    border: "1px solid #97b1de",
    padding: "10px",
  },
  bodytd: {
    color: "#000000",
    width: "auto",
    minWidth: "100px",
    textAlign: "center",
  },
  bodytdBT: {
    minWidth: "150px",
  },
  nthChild: {
    background: "#dae3f3",
  },
  tHead: {
    borderBottom: "2px solid #97b1de",
  },
}));
